var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hasIntegracaoPontoMais)?_c('Alert',{staticClass:"mt-4",attrs:{"dense":"","color":"warning","actionText":_vm.$t('action.seePlans'),"actionIcon":''},on:{"action":_vm.sendToUpgradePlan}},[_vm._v(" "+_vm._s(_vm.$t("signAutomation.alertMassMigrationPlan"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }